"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSendBoxButtonStyle;

function createSendBoxButtonStyle(_ref) {
  var sendBoxButtonColor = _ref.sendBoxButtonColor,
      sendBoxButtonColorOnDisabled = _ref.sendBoxButtonColorOnDisabled,
      sendBoxButtonColorOnFocus = _ref.sendBoxButtonColorOnFocus,
      sendBoxButtonColorOnHover = _ref.sendBoxButtonColorOnHover,
      sendBoxHeight = _ref.sendBoxHeight;
  return {
    backgroundColor: 'Transparent',
    border: 0,
    height: '100%',
    outline: 0,
    padding: 0,
    // We use the sendBoxHeight, so the button looks square
    width: sendBoxHeight,
    '&:not(:disabled)': {
      '&:focus svg': {
        fill: sendBoxButtonColorOnFocus
      },
      '&:hover svg': {
        fill: sendBoxButtonColorOnHover
      }
    },
    '& svg': {
      fill: sendBoxButtonColor
    },
    '&:disabled svg': {
      fill: sendBoxButtonColorOnDisabled
    }
  };
}